import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router";
import classes from "../../Challenge.module.css";
import { toast } from "react-toastify";
import AUTH_CONTEXT from "../../../../store";
import Card from "../../../../components/Card/Card";
import Button from "../../../../components/Button/Button";
import { SuperPowerServices } from "../../../../services/challenge_services";
import { Breadcrumbs, Typography } from "@mui/material";
import { BASE_PATH_TO_SUPER_POWERS_LIST } from "../../../../base_routes_paths/challenge_paths";

const UpdateSuperpower = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const [SuperPowerName, setSuperPowerName] = useState({
        "en-US": "", "en-IN": "", "en-CA": "", "hi-IN": "", "ar-AE": ""
    });
    const [SuperPowerDescription, setSuperPowerDescription] = useState({
        "en-US": "", "en-IN": "", "en-CA": "", "hi-IN": "", "ar-AE": ""
    });
    const [SuperPowerImageUrl, setSuperPowerImageUrl] = useState("");
    const [SuperPowerDuration, setSuperPowerDuration] = useState(0);
    const [SuperPowerDurationType, setSuperPowerDurationType] = useState(1);
    const [SuperPowerMultiplier, setSuperPowerMultiplier] = useState(1);
    const [SuperPowerPointsCost, setSuperPowerPointsCost] = useState(0);
    const [SuperPowerCategory, setSuperPowerCategory] = useState(1);
    const [SuperPowerID, setSuperPowerID] = useState(1);
    const [IsActive, setIsActive] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const { token } = AUTH_CONTEXT();

    const handleInputChange = (setter) => (e) => setter(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const superpowerData = {
                Data: {
                    SuperPowerName,
                    SuperPowerDescription,
                    SuperPowerImageUrl,
                    SuperPowerDuration,
                    SuperPowerDurationType,
                    SuperPowerMultiplier,
                    SuperPowerPointsCost,
                    SuperPowerCategory,
                    SuperPowerID,
                    IsActive
                },
                _id: params.ID
            }

            await SuperPowerServices.addSuperPowers(token, navigate, superpowerData);
            toast.success("Superpower created successfully!");
            navigate(BASE_PATH_TO_SUPER_POWERS_LIST);
        } catch (error) {
            toast.error("Failed to create superpower.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleLocaleChange = (setter) => (e, locale) => {
        setter((prevState) => ({
            ...prevState,
            [locale]: e.target.value
        }));
    };

    const fetchSuperPowerData = async () => {
        try {
            const response = await SuperPowerServices.getSuperPowers(token, navigate, params.ID);
            if (response.status !== 207 && response.data) {
                const superpowerData = response.data[0];
                setSuperPowerName(superpowerData.SuperPowerName || {});
                setSuperPowerDescription(superpowerData.SuperPowerDescription || {});
                setSuperPowerImageUrl(superpowerData.SuperPowerImageUrl || "");
                setSuperPowerDuration(superpowerData.SuperPowerDuration || 0);
                setSuperPowerDurationType(superpowerData.SuperPowerDurationType || 1);
                setSuperPowerMultiplier(superpowerData.SuperPowerMultiplier || 1);
                setSuperPowerPointsCost(superpowerData.SuperPowerPointsCost || 0);
                setSuperPowerCategory(superpowerData.SuperPowerCategory || 1);
                setSuperPowerID(superpowerData.SuperPowerID || 1);
                setIsActive(superpowerData.IsActive !== undefined ? superpowerData.IsActive : true);
                toast.success("Data fetched successfully!");
            } else {
                toast.error(response.error || "Failed to fetch superpower data.");
            }
        } catch (error) {
            toast.error("An error occurred while fetching data.");
        }
    };

    useEffect(() => {
        if (params.ID) {
            fetchSuperPowerData();
        }
    }, [params.ID]);

    return (
        <div className={classes.crumbs}>
            <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" to="/dashboard">Dashboard</Link>
                <Typography color="text.primary">SuperPower</Typography>
                <Typography color="text.primary">Update SuperPower</Typography>
            </Breadcrumbs>
            <Card className={classes.input}>
                <div className={classes.Main_div}>Update SuperPower</div>
                <form onSubmit={handleSubmit}>
                    <div className={classes.subfields}>
                        <h3>SuperPower Name Translations</h3>
                        {Object.keys(SuperPowerName).map((locale) => (
                            <div key={locale} className={classes.control}>
                                <label>{`Name (${locale})`}</label>
                                <input
                                    type="text"
                                    value={SuperPowerName[locale]}
                                    onChange={(e) => handleLocaleChange(setSuperPowerName)(e, locale)}
                                    placeholder={`Enter name for ${locale}`}
                                />
                            </div>
                        ))}
                    </div>

                    <div className={classes.subfields}>
                        <h3>SuperPower Description Translations</h3>
                        {Object.keys(SuperPowerDescription).map((locale) => (
                            <div key={locale} className={classes.control}>
                                <label>{`Description (${locale})`}</label>
                                <input
                                    type="text"
                                    value={SuperPowerDescription[locale]}
                                    onChange={(e) => handleLocaleChange(setSuperPowerDescription)(e, locale)}
                                    placeholder={`Enter description for ${locale}`}
                                />
                            </div>
                        ))}
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerImageUrl">SuperPower Image URL:</label>
                        <input
                            type="text"
                            value={SuperPowerImageUrl}
                            onChange={handleInputChange(setSuperPowerImageUrl)}
                            className={classes.input}
                        />
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerDuration">SuperPower Duration:</label>
                        <input
                            type="number"
                            value={SuperPowerDuration}
                            onChange={handleInputChange(setSuperPowerDuration)}
                            className={classes.input}
                        />
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerDurationType">SuperPower Duration Type:</label>
                        <select
                            value={SuperPowerDurationType}
                            onChange={handleInputChange(setSuperPowerDurationType)}
                        >
                            <option value={1}>One-time use</option>
                            <option value={2}>One-day use</option>
                        </select>
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerMultiplier">SuperPower Multiplier:</label>
                        <input
                            type="number"
                            value={SuperPowerMultiplier}
                            onChange={handleInputChange(setSuperPowerMultiplier)}
                            className={classes.input}
                        />
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerPointsCost">SuperPower Points Cost:</label>
                        <input
                            type="number"
                            value={SuperPowerPointsCost}
                            onChange={handleInputChange(setSuperPowerPointsCost)}
                            className={classes.input}
                        />
                    </div>

                    <div className={classes.selectbox}>
                        <label htmlFor="SuperPowerCategory">SuperPower Category:</label>
                        <select
                            value={SuperPowerCategory}
                            onChange={handleInputChange(setSuperPowerCategory)}
                        >
                            <option value={1}>Challenge</option>
                            <option value={2}>Solo Challenge</option>
                            <option value={3}>Points</option>
                            <option value={4}>Streak</option>
                            <option value={5}>Attempts</option>
                        </select>
                    </div>

                    <div className={classes.control}>
                        <label htmlFor="SuperPowerID">SuperPower ID:</label>
                        <input
                            type="number"
                            value={SuperPowerID}
                            onChange={(e) => setSuperPowerID(parseInt(e.target.value))}
                            placeholder="Enter SuperPower ID"
                            required
                        />
                    </div>

                    <div className={classes.selectbox} style={{ marginBottom: "2rem" }}>
                        <label htmlFor="IsActive">Is Active:</label>
                        <select
                            value={IsActive}
                            onChange={(e) => setIsActive(e.target.value === "true")}
                        >
                            <option value="false">False</option>
                            <option value="true">True</option>
                        </select>
                    </div>

                    <Button type="submit" disabled={isLoading} className={classes.submitButton}>
                        {isLoading ? "Creating..." : "Update  Superpower"}
                    </Button>
                </form>
            </Card>
        </div>
    );
};

export default UpdateSuperpower;
